import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api';
import type { Id } from '../../../convex/_generated/dataModel';

export type { PlayerTrends } from '@/shared/types/evaluation.types';

export interface PlayerDetailData {
  player: {
    id: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string | null;
    age: number | null;
    skillLevel: string | null;
    utrRating: number | null;
    attendancePercent: number;
    totalEvaluations: number;
  };
  evaluations: Array<{
    id: string;
    attitude: number;
    effort: number;
    engagement: number;
    physical: number | null;
    technical: number | null;
    tactical: number;
    competitionLevel: number;
    notes: string | null;
    createdAt: number;
    average: number;
  }>;
  attendance: Array<{
    id: string;
    status: string;
    sessionDate: string;
    startTime: string;
    sessionType: string | null;
    courtNumber: number | null;
  }>;
  stats: {
    attendanceStats: {
      total: number;
      present: number;
      late: number;
      absent: number;
    };
    evalAverages: {
      attitude: number;
      effort: number;
      engagement: number;
      physical: number | null;
      technical: number | null;
      tactical: number | null;
    } | null;
  };
}

export function useCoachPlayers(search?: string, level?: string, ballLevel?: string) {
  const data = useQuery(api.coach.players.list, { search, level, ballLevel });
  return { data, isLoading: data === undefined, error: null };
}

export function usePlayerTrends(playerId: string) {
  const data = useQuery(
    api.coach.players.getTrends,
    playerId ? { playerId: playerId as Id<"players"> } : 'skip'
  );
  return { data, isLoading: data === undefined, error: null };
}

export function usePlayerDetail(playerId: string | null) {
  const data = useQuery(
    api.coach.players.getDetail,
    playerId ? { playerId: playerId as Id<"players"> } : 'skip'
  );
  return { data, isLoading: data === undefined, error: null };
}
